import { type DatabaseChangeType } from '@databases/types/redux';

import { calculationToCollabMapping } from '../../../collab/convert-to-collab';
import { type YJSChangeHandler } from '../../types';

export const setSavedViewCalculations: YJSChangeHandler<
  DatabaseChangeType.SET_SAVED_VIEW_CALCULATIONS
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const view = db.viewsById[change.viewId];

    if (view) {
      view.setCalculation(change.fieldId, calculationToCollabMapping[change.value]);
    }
  });
};
